import { useState } from 'react';
import { useCmsContent } from '../hooks/useCmsContent';
import { FALLBACK_CONSULTING } from '../components/consulting/consulting-data';
import { ConsultingHero } from '../components/consulting/ConsultingHero';
import { ConsultingTab1 } from '../components/consulting/ConsultingTab1';
import { ConsultingTab2 } from '../components/consulting/ConsultingTab2';
import { ConsultingContact } from '../components/consulting/ConsultingContact';

export const ConsultingPage = () => {
  const cms = useCmsContent('consulting', FALLBACK_CONSULTING);
  const [activeTab, setActiveTab] = useState('tab1');

  return (
    <div className="bg-[#F8FAFC]" data-testid="consulting-page">
      <ConsultingHero cms={cms} />

      {/* Tabs Nav */}
      <div className="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm" data-testid="tabs-nav" style={{ top: '72px' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex overflow-x-auto">
          {[
            { id: 'tab1', num: 'I', label: 'Conseil & Création d\'entreprise' },
            { id: 'tab2', num: 'II', label: 'Accompagnement RH' }
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-3 px-8 py-5 text-sm font-medium whitespace-nowrap border-b-[3px] transition-all ${activeTab === tab.id ? 'text-[#1F2937] border-[#F59E0B] font-semibold' : 'text-gray-400 border-transparent hover:text-gray-600'}`}
              data-testid={`tab-${tab.id}`}
            >
              <span className={`w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold transition-all ${activeTab === tab.id ? 'bg-[#F59E0B] text-white' : 'bg-slate-100 text-gray-400'}`}>
                {tab.num}
              </span>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {activeTab === 'tab1' ? <ConsultingTab1 /> : <ConsultingTab2 />}
      <ConsultingContact />
    </div>
  );
};

export default ConsultingPage;
